import members from 'assets/image/icons/svg/people-group-active.svg'
import invited from 'assets/image/icons/svg/sent-inventActive.svg'
import statistics from 'assets/image/icons/svg/statisticsActive.svg'

const enum TeamSideId {
	Members,
	Statistics,
	Invites
}

const SIDEBAR_ITEMS = [
	{
		id: TeamSideId.Members,
		image: members,
		link: '/team/members',
		title: 'Members'
	},
	{
		id: TeamSideId.Statistics,
		image: statistics,
		link: '/team/statistics',
		title: 'Statistics'
	},
	{
		id: TeamSideId.Invites,
		image: invited,
		link: '/team/invitations',
		title: 'Pending invites'
	}
]

export { SIDEBAR_ITEMS, TeamSideId }
